import { blankMonitor } from 'utils/blankMonitor';
import { addRadarEvent } from 'utils/businesslog';

blankMonitor.monitor((err: Error) => {
    addRadarEvent({
        name: 'SLI_DMP_GLOBAL_BLANK_ERR',
        event_type: 'blank',
        result_type: 'fail',
        message: err?.message,
        extra_info: err?.toString(),
    });
});
